import React, { useEffect } from 'react';
import {
  useStyles
} from '../Dashboard.style';
import { parseJSON } from 'src/utils/common.util';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import accountService from 'src/services/account.service';
// import Tooltip from '@material-ui/core/Tooltip';

interface ISingleDocument {
  documents: {
    id: string;
    secureId: string;
    status: string;
    name: string;
    submissionId?: number;
    secureSubmissionId?: string;
  }[];
  totalResults: number;
}

interface ILegalGuardianDocument {
  documents: {
    id: string;
    secureId: string;
    status: string;
    name: string;
    submissionId?: number;
    secureSubmissionId?: string;
  }[];
  totalResults: number;
  hasMore: boolean;
  nameFirst: string;
  nameLast: string;
}

type Document = ILegalGuardianDocument | ISingleDocument;

interface IProps {
  cookies: {
    userInfo: {
      name: { nameFirst: string; nameLast: string };
    };
    role: string;
    token: string;
  };
}

const AccountInfo: React.FC<IProps> = ({ cookies }) => {
  const [isLoading, _] = React.useState<boolean>(false);

  const classes = useStyles();

  const [account, setAccount] = React.useState<any>({});

  useEffect(() => {
    accountService.getAccountSettings(parseJSON('tenantInfo').accountId).then((data) => {
      setAccount(data);
    });
  }, [

  ])

  return (
    <LoadingContainer isLoading={isLoading}>
      <div>
        <p
          className={`${classes.messageInfo} ${classes.mt15}`}
        >
          {account?.companyName}
        </p>


        <p className={classes.messageInfoDescription}>
          {/* <Tooltip
            title="Please be advised that the address specified here may not match the selected location for your appointment."
          > */}
          <span>
            {account?.postalAddress?.street} {account?.postalAddress?.street2}, {account?.postalAddress?.city}, {account?.postalAddress?.state}, {account?.postalAddress?.zipcode}
          </span>
          {/* </Tooltip> */}
        </p>

        <p>
          <a className={classes.messageInfoPhone} href={`tel:${account?.officeNumber}`}> {account?.officeNumber}</a>
        </p>
      </div>
    </LoadingContainer>
  );
};

export default AccountInfo;
